import React from 'react';
import { Preloader } from '../../shared/svg/components';

const MainLoader = () => (
  <div className="main-loader">
    <div className="container-icon">
      <Preloader className="icon" />
    </div>
  </div>
  );

export default MainLoader;
